"use client";

import { signIn } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";

export default function () {
  const oneTapRef = useRef<null | ((options: Record<string, unknown>, cb: (response: any) => void) => void)>(null);
  const hasPromptedRef = useRef(false);
  const isSigningInRef = useRef(false);
  const { status } = useSession();

  const loadOneTap = async () => {
    if (oneTapRef.current) {
      return oneTapRef.current;
    }
    const mod = await import("google-one-tap");
    oneTapRef.current = mod.default;
    return oneTapRef.current;
  };

  const oneTapLogin = async function () {
    const clientId = process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID;
    if (!clientId) return;

    const options = {
      client_id: clientId,
      auto_select: false,
      cancel_on_tap_outside: false,
      context: "signin",
    };

    const googleOneTap = await loadOneTap();
    if (!googleOneTap) return;

    googleOneTap(options, (response: any) => {
      if (typeof response?.credential === "string") {
        void handleLogin(response.credential);
      }
    });
  };

  const handleLogin = async function (credentials: string) {
    if (!credentials || isSigningInRef.current) return;

    isSigningInRef.current = true;
    try {
      await signIn("google-one-tap", {
        credential: credentials,
        redirect: false,
      });
    } catch {
      // Failed One Tap attempts should not pollute the browser console.
    } finally {
      isSigningInRef.current = false;
    }
  };

  useEffect(() => {
    if (status === "unauthenticated") {
      if (hasPromptedRef.current) return;
      hasPromptedRef.current = true;
      void oneTapLogin();
      return;
    }

    if (status === "authenticated") {
      hasPromptedRef.current = false;
    }
  }, [status]);

  return <></>;
}
